import TimelineTag from './TimelineTag.component';

export default TimelineTag;